import { Spinner } from "~/components/ui/spinner";

export function LoadingStep() {
  return (
    <div className="bg-background flex items-center justify-center rounded-lg border p-12">
      <Spinner className="size-8" />
    </div>
  );
}
